import { render, staticRenderFns } from "./surroundBox4.vue?vue&type=template&id=4339cb9b&scoped=true"
import script from "./surroundBox4.vue?vue&type=script&lang=js"
export * from "./surroundBox4.vue?vue&type=script&lang=js"
import style0 from "./surroundBox4.vue?vue&type=style&index=0&id=4339cb9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4339cb9b",
  null
  
)

export default component.exports